import React from 'react';

import { standardSchemaResolver } from '@hookform/resolvers/standard-schema';
import { UseFormReturn, useForm } from 'react-hook-form';

import { FileModel } from '@/models/FileModel.ts';
import { Form } from '@/uiKit/atoms/Form';
import {
  GeneratePrescriptionInfo,
  PrescriptionInfo,
  prescriptionInfoSchema,
} from '@/uiKit/organisms/PatientCreationAndRenewal/PrescriptionInfo/PrescriptionInfo.ts';

export const PRESCRIPTION_INFO_FORM_ID = 'prescription-info-form';
export type PrescriptionInfoFormProps = {
  prescriptionInfo: Partial<PrescriptionInfo>;
  onGeneratePrescription: (prescriptionInfo: GeneratePrescriptionInfo) => void;
  onUploadPrescription: (file: FileModel) => void;
  className?: string;
  children?:
    | React.ReactNode
    | ((formContext: UseFormReturn<PrescriptionInfo>) => React.ReactNode);
};

export const PrescriptionInfoForm: React.FC<PrescriptionInfoFormProps> = ({
  prescriptionInfo,
  onGeneratePrescription,
  onUploadPrescription,
  children,
  className,
}) => {
  const form = useForm<PrescriptionInfo>({
    resolver: standardSchemaResolver(prescriptionInfoSchema),
    defaultValues: prescriptionInfo,
  });

  const onSubmit = (data: PrescriptionInfo) => {
    if ('file' in data && data.file && data.file.name) {
      onUploadPrescription(data.file);
    } else {
      onGeneratePrescription(data as GeneratePrescriptionInfo);
    }
  };

  return (
    <Form
      id={PRESCRIPTION_INFO_FORM_ID}
      formContext={form}
      onSubmit={onSubmit}
      className={className}
    >
      {typeof children === 'function' ? children(form) : children}
    </Form>
  );
};
